import OrderProgress from "../../components/OrderProgress/OrderProgress";
import "./CheckOutPayment.scss";
import React, {useEffect, useState} from "react";
import Cookies from "js-cookie";
import GoingBack from "../../components/GoingBack/GoingBack";
import {Loader} from "../../utils/Loader";
import {Link, useNavigate} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft, faCircleInfo} from "@fortawesome/free-solid-svg-icons";
import ButtonDeconnect from "../../components/Button Deconnect/ButtonDeconnect";
import AccountActiveOrNot from "../../components/AccountActiveOrNot/AccountActiveOrNot";
import TextAccountNotActiveWithDeconnectButton
    from "../../components/AccountActiveOrNot/TextAccountNotActiveWithDeconnectButton";
import Swal from "sweetalert2";

function CheckoutPayment() {
    const [adresse, setAdresse] = useState([]);
    const [pointRelais, setPointRelais] = useState(Cookies.get("MondialRelayPointDetails") ? JSON.parse(Cookies.get("MondialRelayPointDetails")) : {});
    const [products, setProducts] = useState([])
    const [totalCommande, setTotalCommande] = useState(0);
    const [totalCommandeWithPromo, setTotalCommandeWithPromo] = useState(0);
    const [conditionsAccepter, setConditionsAccepter] = useState(false);
    const [erreurConditionsNonAccepter, setErreurConditionsNonAccepter] = useState("");
    const [isDataLoading, setDataLoading] = useState(false);
    const [paiementOk, setPaiementOk] = useState(false);
    const codePromoActif = localStorage.getItem("codePromoActif");
    const [accountActive, setAccountActive] = useState(null);
    const [codePromo, setCodePromo] = useState(
        codePromoActif && codePromoActif !== "" ? JSON.parse(codePromoActif) : {}
    );
    const navigate = useNavigate();
    useEffect(() => {
        window.scrollTo(0, 0);
        document.title = "Récapitulatif commande";
        const cartItems = JSON.parse(localStorage.getItem("cart"));
        if (!cartItems || cartItems.length === 0) {
            navigate("/panier");
        }
        try {
            const fetchData = async () => {
                if (Cookies.get('adresseId')) {
                    setDataLoading(true);
                    const response = await fetch(`${process.env.REACT_APP_API_URL}adresses/${Cookies.get("adresseId")}`,
                        {
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${Cookies.get("auth_token")}`,
                            },
                        });
                    const adresse = await response.json();
                    setAdresse(Object.values(adresse));
                }

                const getProducts = await fetch(`${process.env.REACT_APP_API_URL}panier`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${Cookies.get("auth_token")}`,
                        },
                    });
                const products = await getProducts.json();
                setProducts(Object.values(products.contenuPanier));
                setTotalCommande(products.total);
                setTotalCommandeWithPromo(codePromoActif !== null ? products.total - (products.total * codePromo.reductionValeurEntier / 100) : products.total)
                setDataLoading(false);
                Cookies.remove("MondialRelayPoint");
            }
            fetchData();
        } catch (error) {
            console.log(error)
        }
    }, []);

    const handleClickPayerCommande = () => {
        if (!conditionsAccepter) {
            setErreurConditionsNonAccepter("Vous devez accepter les conditions générales de ventes pour continuer");
            return;
        }
        const payerCommande = async () => {
            const response = await fetch(`${process.env.REACT_APP_API_URL}payment/create-checkout-session`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${Cookies.get("auth_token")}`,
                    },
                    body: JSON.stringify({
                        products: products,
                        codePromo: codePromo.reduction,
                        idCodePromoStripe: codePromo.idCodePromoStripe,
                        fraisLivraisonType: Cookies.get("adresseId") ? "domicile" : "pointRelais"
                    })
                });
            const result = await response.json();
            if (response.ok) {
                setPaiementOk(true);
                window.location.href = result.url;
            } else if (response.status === 500) {
                console.log(result);
                Swal.fire({
                    icon: "error",
                    title: "Erreur lors de la création du paiment de votre commande",
                    text: "Veuillez contacter le support pour plus d'informations, ou bien réessayer plus tard. Nous sommes navré pour la gêne occasionnée.",
                });
            }
        }
        payerCommande();
    }

    const handleGoBack = () => {
        console.log("go back")
        navigate("/checkout/delivery");
    }

    return (
        <>
            <AccountActiveOrNot setAccountActive={setAccountActive}/>
            {accountActive === false && accountActive !== null ? (
                <TextAccountNotActiveWithDeconnectButton/>
            ) : (
                <div className="checkout-payment-container">
                    <div style={{display: "flex", justifyContent: "center", marginBottom: "2rem"}}>
                        <a href="/">
                            <img src="https://res.cloudinary.com/dc1p20eb2/image/upload/v1711445140/Anne%27so%20Naturelle/logo/logo.png"
                                 alt="logo anneso-naturelle" height="125" width="200" />
                        </a>
                    </div>

                    <div className="return-to-collection" onClick={handleGoBack}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                        Retour à la livraison
                    </div>

                    <OrderProgress/>

                    {isDataLoading ? (
                        <div style={{display: "flex", alignItems: "center", justifyContent: "center", marginTop: "3rem"}}>
                            <Loader/>
                        </div>
                    ) : (
                        <div className="main-div-checkout-payment">
                            
                            {/* Colonne de Gauche : Articles et Détails de livraison */}
                            <div className="payment-left-column">
                                <div className="payment-section-card">
                                    <h2>Articles de votre commande</h2>
                                    <hr />
                                    <div className="payment-products-list">
                                        {products && products.map((product, index) => (
                                            <div className="div-secondary-details-products" key={index}>
                                                <div className="product-payment-info">
                                                    <img src={product.cover} height={80} width={80} alt={product.name} />
                                                    <div className="product-payment-text">
                                                        <h4>{product.name}</h4>
                                                        {product.informationsComplementaires && (
                                                            <div className="info-complementaire">
                                                                <FontAwesomeIcon icon={faCircleInfo} />
                                                                <span>{product.informationsComplementaires}</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="product-payment-price">
                                                    <h4>{product.price.toFixed(2)} €</h4>
                                                    <p>Quantité : {product.amount}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {(Cookies.get("MondialRelayPointDetails") || Cookies.get("adresseId")) && (
                                    <div className="payment-section-card">
                                        <h2>Informations de Livraison</h2>
                                        <hr />
                                        
                                        {Cookies.get("MondialRelayPointDetails") && pointRelais && (
                                            <div className="delivery-recap">
                                                <p style={{fontWeight: 600, color: "#1e293b", marginBottom: "0.5rem"}}>Point Relais Sélectionné</p>
                                                <p>{pointRelais.LgAdr1}</p>
                                                <p>{pointRelais.LgAdr3}</p>
                                                <p>{pointRelais.CP} {pointRelais.Ville}</p>
                                                {pointRelais.URL_Photo && (
                                                    <img src={pointRelais.URL_Photo} alt="photo point relais" style={{maxWidth: "300px"}} />
                                                )}
                                            </div>
                                        )}

                                        {Cookies.get("adresseId") && adresse.length > 0 && (
                                            <div className="delivery-recap">
                                                <p style={{fontWeight: 600, color: "#1e293b", marginBottom: "0.5rem"}}>Livraison à Domicile</p>
                                                <p>{adresse[2]} {adresse[3]}</p>
                                                <p>{adresse[4]}</p>
                                                <p>{adresse[5]} {adresse[6]}</p>
                                                <p>{adresse[8]}</p>
                                                <p>{adresse[9]}</p>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>

                            {/* Colonne de Droite : Résumé de Paiement (Sticky) */}
                            <div className="payment-right-column">
                                <div className="payment-summary-card">
                                    <h3>
                                        Total TTC
                                        <span className="total-price">
                                            {(totalCommandeWithPromo > 50 ? totalCommandeWithPromo : totalCommandeWithPromo + (Cookies.get("adresseId") ? 5.90 : 3.90)).toFixed(2)} €
                                        </span>
                                    </h3>
                                    <hr />

                                    <div className="summary-line">
                                        <span>Sous-total articles</span>
                                        <span>{totalCommande.toFixed(2)} €</span>
                                    </div>

                                    <div className="summary-line">
                                        <span>Frais de livraison</span>
                                        <span>
                                            {totalCommande.toFixed(2) >= 50.00 ? "Offerts" : (Cookies.get("adresseId") ? "5.90 €" : "3.90 €")}
                                        </span>
                                    </div>

                                    {codePromoActif !== null && (
                                        <div className="summary-line discount-line">
                                            <span>Réduction appliquée</span>
                                            <span>- {(totalCommande * codePromo.reduction).toFixed(2)} €</span>
                                        </div>
                                    )}

                                    <div className="cgv-checkbox-container">
                                        <input
                                            type="checkbox"
                                            id="conditionsCheckbox"
                                            checked={conditionsAccepter}
                                            onChange={(e) => setConditionsAccepter(e.target.checked)}
                                        />
                                        <label htmlFor="conditionsCheckbox">
                                            J'ai lu et j'accepte les <a href="/informations/conditions-generales-ventes-et-utilisations">conditions générales de ventes</a>
                                        </label>
                                    </div>

                                    {erreurConditionsNonAccepter && !conditionsAccepter && (
                                        <div className="error-cgv">
                                            {erreurConditionsNonAccepter}
                                        </div>
                                    )}

                                    <button className="btn-pay-order" onClick={() => handleClickPayerCommande()}>
                                        Payer ma commande
                                    </button>
                                </div>
                            </div>

                        </div>
                    )}
                </div>
            )}
        </>
    )
}

export default CheckoutPayment;
